import { Component, inject, signal } from '@angular/core';
import {
	MAT_DIALOG_DATA,
	MatDialogActions,
	MatDialogContent,
	MatDialogRef,
	MatDialogTitle,
} from '@angular/material/dialog';
import { TranslocoPipe } from '@jsverse/transloco';
import { LvrButton } from './lvr-button/lvr-button';

export interface FinalizeReportDialogData {
	onConfirm: () => Promise<void>;
	onError: () => void;
}
@Component({
	selector: 'lvr-finalize-report-dialog',
	template: `
		<h2 mat-dialog-title>{{ 'assignment.report.finalize' | transloco }}</h2>
		<mat-dialog-content>
			<p>
				{{ 'assignment.report.finalize_hint' | transloco }}
			</p>
		</mat-dialog-content>
		<mat-dialog-actions class="actions-row">
			<lvr-button
				variant="secondary"
				[label]="'base.button.cancel' | transloco"
				type="button"
				[disabled]="isLoading()"
				(clicked)="dialogRef.close(false)"
				icon="disabled_by_default"
			/>
			<lvr-button
				variant="primary"
				[label]="'base.button.submit' | transloco"
				type="button"
				[loading]="isLoading()"
				[loadingLabel]="'base.button.submitting' | transloco"
				(clicked)="confirm()"
				icon="ios_share"
			/>
		</mat-dialog-actions>
	`,
	styles: [
		`
			.full-width {
				width: 100%;
				margin-top: 16px;
			}
		`,
	],
	imports: [MatDialogTitle, MatDialogContent, MatDialogActions, TranslocoPipe, LvrButton],
})
export class LvrFinalizeReportDialog {
	public readonly dialogRef = inject(MatDialogRef<LvrFinalizeReportDialog>);
	private readonly data = inject<FinalizeReportDialogData>(MAT_DIALOG_DATA);

	public readonly isLoading = signal(false);

	public async confirm(): Promise<void> {
		if (this.isLoading()) return;

		this.isLoading.set(true);
		this.dialogRef.disableClose = true;

		try {
			await this.data.onConfirm();
			this.dialogRef.close(true);
		} catch {
			this.data.onError();
		} finally {
			this.isLoading.set(false);
			this.dialogRef.disableClose = false;
		}
	}
}
